import React from "react";

interface IconProps {
  icon?: any;
  className?: string;
  style?: React.CSSProperties;
}

const IconComponent: React.FC<IconProps> = ({
  icon: Icon,
  className,
  style,
}) => {
  if (!Icon) return null;

  return <Icon className={className} style={style} />;
};

export default IconComponent;
